<template>
  <div>
    <vz-toggler
      v-model="isProject"
      class="mr-10 flex pdf-order-section-hide"
      variant="primary"
      :disabled="disabled"
      @change="isProject = !isProject"
    >
      <span class="fs-16 toggle-project-label">
        Использовать проект
      </span>
    </vz-toggler>

    <project-autocomplete
      class="mt-20 mb-20"
      v-model="projectGuid"
      big
      :disabled="disabled"
      @changeGuidContractor="changeContract($event)"
    />
  </div>
</template>

<script setup lang="ts">
import {useOrderStore} from "~/stores/order";
import useMembers from "~/composables/useMembers";
import {PropType} from "vue";
import {DirectionName} from "~/types/types";
import ProjectAutocomplete from "~/components/autocomplete/project-autocomplete.vue";
import VzToggler from "~/components/ui-kit/vz-toggler.vue";
import {getContractor} from "~/api/contractor";
import {deepCopyObject} from "~/common/functions";
import {storeToRefs} from "pinia";

const emit = defineEmits(['update:isProject'])

const props = defineProps({
  direction: {
    type: String as PropType<DirectionName>,
    default: 'dispatch'
  },
  isOrderPage: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const orderStore = useOrderStore()
const { orderForm } = storeToRefs(useOrderStore())
const {onChangeContractor} = useMembers(props)

const projectGuid = computed({
  get() {
    return orderStore.orderForm.customer.projectGuid
  },
  set(value: string|null) {
    orderStore.orderForm.customer.projectGuid = value
  }
})
const isProject = ref(!!projectGuid.value);
const saveProjectContactorGuid = ref('');

async function changeContract(projectContractGuid: string) {
  saveProjectContactorGuid.value = projectContractGuid;
  isProject.value = true;

  // изменяем type
  orderStore.orderForm.customer[props.direction].type = 'corporation'

  // получаем contractor
  const contractor = await getContractor(projectContractGuid, undefined, true);

  await onChangeContractor(contractor.name, contractor)
}

watch(() => props.direction, (newDirection, oldDirection) => {
  if (isProject.value && projectGuid.value && saveProjectContactorGuid.value) {
    const tempNewDirection = deepCopyObject(orderForm.value.customer[newDirection])
    orderForm.value.customer[newDirection] = deepCopyObject(orderForm.value.customer[oldDirection])
    orderForm.value.customer[oldDirection] = tempNewDirection;
  }
})

watch(() => isProject.value, (isProjectValue) => {
  if (!isProjectValue) {
    orderStore.orderForm.customer.projectGuid = null
  }

  emit('update:isProject', isProjectValue)
})

watch(() => projectGuid.value, (projectGuidValue) => {
  if (!projectGuidValue) {
    isProject.value = false;
    return;
  }

  isProject.value = true;
})

onBeforeUnmount(() => {
  orderStore.orderForm.customer.projectGuid = null
})
</script>

<style scoped lang="scss">
.toggle-project-label {
  line-height: 23px;
}
</style>
